import React from 'react';
import Head from 'next/head';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import TextSection from '../../components/TextSection';
import ActionSection from '../../components/ActionSection';

import styles from './styles.module.scss'
import ConsultancyBackground from '../../public/assets/images/consultancy-background.jpg';
import ConsultancyImage from '../../public/assets/images/consultancy-image.jpg';


export default function ConsultancyPage()  {
  return (
    <>
      <Head>
        <title>Consultancy | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={ConsultancyBackground.src}>
        <h1 className='page-header-h1'>Consultancy.</h1>
      </PageHeader>

      <div className={`${styles.consultancyPage} page-holder`}>
        <TextSection 
          header="At Nevo Advisory, we can help manage your fleet transition from vehicle selection to charging options."
          text="This will help your ESG and CSR goals. From lowering your running costs to managing your carbon footprint, we have the solution."
        />

        <div 
          className={`${styles.consultancyImage} image-section section`} 
          style={{ backgroundImage: `url(${ConsultancyImage.src})` }}
        >&nbsp;</div>

        <ActionSection 
          header="Arrange an initial call"
          text="At Nevo Advisory, we can help manage your fleet transition from vehicle selection to charging options. This will help your ESG and CSR goals. From lowering your running costs to managing your carbon footprint, we have the solution."
          buttonText="Contact Us"
          href="/contact-us"
        />
      </div>

      <Footer />
    </>
  )
};
